import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './constants';
import * as actions from './upload-xml-actions';

export function* uploadXMLFile(action) {
  try {
    // eslint-disable-next-line prefer-destructuring
    const file = action.payload.file;
    const data = new FormData();
    data.append('file', file, file.name);

    const results = yield call(callApi, {
      endpoint: 'order/upload',
      options: {
        method: 'POST',
        body: data,
        errorMessage: 'Could not upload order XML.',
        retryAction: action,
        disableContentType: true,
      },
    });
    yield put(actions.uploadFileSuccess(results));
  } catch (err) {
    yield put(actions.uploadFileFailure(err));
  }
}

export function* createXMLOrder(action) {
  try {
    const id = action.payload.info?.EquipmentId;
    const { blobReference, skipNotFound, duplicates, poNumber } = action.payload;

    const request = {
      equipmentId: id,
      blobReference,
      skipNotFound,
      duplicates,
      poNumber,
    };

    const results = yield call(callApi, {
      endpoint: 'order/upload/trigger',
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: 'Could not create order XML.',
        retryAction: action,
      },
    });
    yield put(actions.createXMLSuccess(results));
  } catch (err) {
    yield put(actions.createXMLFailure(err));
  }
}

export function* doUploadAction(action) {
  try {
    const { multiLineActions, multiLineXmlHeaderInfo, uri } = action.payload;

    const request = {
      multiLineActions,
      multiLineXmlHeaderInfo,
    };

    const results = yield call(callApi, {
      endpoint: uri,
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: 'Could not create order XML.',
        retryAction: action,
      },
    });
    yield put(actions.uploadActionSuccess(results));
  } catch (err) {
    yield put(actions.uploadActionFailure(err));
  }
}

function* watchUploadXMLFile() {
  yield takeLatest(types.UPLOAD_FILE_REQUEST, uploadXMLFile);
}

function* watchCreateXMLOrder() {
  yield takeLatest(types.CREATE_XML_REQUEST, createXMLOrder);
}

function* watchUploadAction() {
  yield takeLatest(types.UPLOAD_ACTION_REQUEST, doUploadAction);
}

export default [fork(watchUploadXMLFile), fork(watchCreateXMLOrder), fork(watchUploadAction)];
